var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boximg"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.img,"alt":"une image"}})]),_c('div',{staticClass:"texte"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('p',{staticClass:"linkcontainer"},[_c('router-link',{staticClass:"coloree",attrs:{"to":"/startseite"}},[_vm._v(_vm._s(_vm.btText))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }